<template lang="pug">
  server-data(
    :method="getMeeting"
    v-slot="{ loading, serverData }"
  )
    v-row.mx-0
      v-col(v-if="loading")
        sdo-loader
      v-col(v-if="!loading && serverData")
        //- v-row.pa-0.ma-0.mb-2
        h2 Урок: {{serverData.name}}
          //- sdo-back-button
        jazz-sdk.mb-5(:meeting="serverData")
</template>

<script>
import JazzSdk from '@/components/Meetings/JazzSdk.vue';

export default {
  components: {
    JazzSdk,
  },
  methods: {
    getMeeting() {
      return this.$api.meeting.getMeeting(this.$route.params.id);
    },
  },
};
</script>
